/* Zayla collection bar — chips, facet drawer openers, custom sort.
   Rides on Broadcast's collection-filters-form AJAX machinery:
   - chips + sort call the custom element's submitForm() so URL, history,
     grid, sidebar, and counts all update through the theme's own pipeline.
   - facet buttons proxy-click the hidden [data-aria-toggle] so collection.js
     runs its normal slide-out open (scroll lock + focus trap).
   Chip modes (7/26):
   - tag chips  (data-tags)    — rebuild filter.p.tag params on this collection.
   - URL chips  (data-zch-url) — cross-page chips navigate like plain links;
     same-page chips (?sort_by=…, ?filter.p.t.category=…) merge their params
     into the current URL (preserving unrelated filters) and AJAX via
     submitForm. Active state compares only the param keys any chip on the
     page cares about, so foreign filters never strand the row. */
(function () {
  'use strict';
  if (window.zchInit) return;
  window.zchInit = true;

  function filtersFormEl() {
    return document.querySelector('[data-collection-sidebar] collection-filters-form');
  }

  function currentParams() {
    return new URLSearchParams(window.location.search);
  }

  function allChips() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-zch-chip]'));
  }

  function chipUrl(chip) {
    var raw = chip.dataset.zchUrl;
    if (raw == null || raw === '') {
      if (raw === '' ) return new URL(window.location.pathname, window.location.origin);
      return null;
    }
    try {
      return new URL(raw, window.location.origin);
    } catch (err) {
      return null;
    }
  }

  function relevantKeys() {
    var keys = {};
    allChips().forEach(function (chip) {
      var u = chipUrl(chip);
      if (u) u.searchParams.forEach(function (v, k) { keys[k] = 1; });
      if ((chip.dataset.tags || '').split('||').filter(Boolean).length) keys['filter.p.tag'] = 1;
    });
    delete keys.page;
    return Object.keys(keys);
  }

  function syncChips() {
    var chips = allChips();
    if (!chips.length) return;
    var cur = currentParams();
    var rk = relevantKeys();
    var activeTags = cur.getAll('filter.p.tag').sort().join('||');
    chips.forEach(function (chip) {
      var u = chipUrl(chip);
      var active = false;
      if (u) {
        if (u.pathname === window.location.pathname) {
          active = rk.every(function (k) {
            return cur.getAll(k).sort().join('||') === u.searchParams.getAll(k).sort().join('||');
          });
        }
      } else {
        var tags = (chip.dataset.tags || '').split('||').filter(Boolean).sort().join('||');
        active = tags.length > 0 && tags === activeTags;
      }
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function syncSort() {
    var params = currentParams();
    var value = params.get('sort_by') || document.querySelector('[data-zch-sort-default]')?.dataset.zchSortDefault || '';
    document.querySelectorAll('[data-zch-sort-option]').forEach(function (opt) {
      var selected = opt.dataset.value === value;
      opt.classList.toggle('is-selected', selected);
      if (selected) {
        document.querySelectorAll('[data-zch-sort-label]').forEach(function (l) { l.textContent = opt.textContent.trim(); });
      }
    });
  }

  function closeSortMenu() {
    var menu = document.querySelector('[data-zch-sort-menu]');
    if (menu && !menu.hidden) {
      menu.hidden = true;
      document.querySelectorAll('[data-zch-sort-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-zch-chip]');
    var facet = e.target.closest('[data-zch-facet]');
    var sortToggle = e.target.closest('[data-zch-sort-toggle]');
    var sortOption = e.target.closest('[data-zch-sort-option]');

    if (chip) {
      var u = chip.dataset.zchUrl != null ? chipUrl(chip) : null;
      var params, qs, url, el;
      if (u) {
        if (u.pathname !== window.location.pathname) return; // cross-page chip: plain navigation
        e.preventDefault();
        params = currentParams();
        relevantKeys().forEach(function (k) { params.delete(k); });
        params.delete('page');
        u.searchParams.forEach(function (v, k) { params.append(k, v); });
        qs = params.toString();
        url = window.location.pathname + (qs ? '?' + qs : '');
        el = filtersFormEl();
        if (el && typeof el.submitForm === 'function') {
          el.submitForm(null, url);
          syncChips();
          syncSort();
        } else {
          window.location.href = url;
        }
        return;
      }
      e.preventDefault();
      params = currentParams();
      params.delete('filter.p.tag');
      params.delete('page');
      (chip.dataset.tags || '').split('||').filter(Boolean).forEach(function (t) {
        params.append('filter.p.tag', t);
      });
      qs = params.toString();
      url = window.location.pathname + (qs ? '?' + qs : '');
      el = filtersFormEl();
      if (el && typeof el.submitForm === 'function') {
        el.submitForm(null, url);
        syncChips();
      } else {
        window.location.href = url;
      }
      return;
    }

    if (facet) {
      e.preventDefault();
      var toggleBtn = document.querySelector('[data-zch-drawer-toggle]');
      if (toggleBtn) toggleBtn.click();
      var group = facet.dataset.zchFacet;
      if (group) {
        setTimeout(function () {
          var sidebar = document.querySelector('[data-collection-sidebar]');
          if (!sidebar) return;
          sidebar.querySelectorAll('.filter-group').forEach(function (g) {
            var heading = g.querySelector('.filter-group__heading span');
            if (heading && heading.textContent.trim().toLowerCase().indexOf(group.toLowerCase()) === 0) {
              var details = g.querySelector('details');
              if (details && !details.open) details.open = true;
              g.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
          });
        }, 350);
      }
      return;
    }

    if (sortToggle) {
      e.preventDefault();
      var menu = document.querySelector('[data-zch-sort-menu]');
      if (!menu) return;
      var opening = menu.hidden;
      if (opening) {
        var zch = sortToggle.closest('.zch');
        if (zch) {
          var tr = sortToggle.getBoundingClientRect();
          var zr = zch.getBoundingClientRect();
          menu.style.top = Math.round(tr.bottom - zr.top + 10) + 'px';
        }
        menu.hidden = false;
        sortToggle.setAttribute('aria-expanded', 'true');
      } else {
        closeSortMenu();
      }
      return;
    }

    if (sortOption) {
      e.preventDefault();
      var input = document.querySelector('[data-zch-sort-input]');
      if (input) {
        input.value = sortOption.dataset.value;
        input.disabled = false;
      }
      document.querySelectorAll('[data-zch-sort-option]').forEach(function (o) { o.classList.toggle('is-selected', o === sortOption); });
      document.querySelectorAll('[data-zch-sort-label]').forEach(function (l) { l.textContent = sortOption.textContent.trim(); });
      closeSortMenu();
      var formEl = filtersFormEl();
      if (formEl && typeof formEl.submitForm === 'function') {
        formEl.submitForm(null);
      } else {
        var p = currentParams();
        p.set('sort_by', sortOption.dataset.value);
        p.delete('page');
        window.location.href = window.location.pathname + '?' + p.toString();
      }
      return;
    }

    if (!e.target.closest('[data-zch-sort-menu]')) closeSortMenu();
  });

  document.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') closeSortMenu();
  });

  window.addEventListener('popstate', function () {
    syncChips();
    syncSort();
  });

  syncChips();
  syncSort();

  /* Adaptive no-crop zoom for thumbnail chips — same approach as upsell-grid.js:
     sample the photo, find the product footprint vs. background, scale up without
     ever cropping the piece. Padded shots zoom, full-bleed shots stay at 1. */
  (function () {
    var CAP = 1.8;
    var MARGIN = 0.94;
    var SAMPLE = 96;
    var TARGET = 0.68;

    function computeZoom(probe) {
      var c = document.createElement('canvas');
      c.width = c.height = SAMPLE;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(probe, 0, 0, SAMPLE, SAMPLE);
      var d = ctx.getImageData(0, 0, SAMPLE, SAMPLE).data;
      function pick(i, j) {
        var p = (j * SAMPLE + i) * 4;
        return [d[p], d[p + 1], d[p + 2]];
      }
      var corners = [pick(2, 2), pick(SAMPLE - 3, 2), pick(2, SAMPLE - 3), pick(SAMPLE - 3, SAMPLE - 3)];
      var bg = [0, 1, 2].map(function (k) {
        return (corners[0][k] + corners[1][k] + corners[2][k] + corners[3][k]) / 4;
      });
      var minX = SAMPLE, maxX = 0, minY = SAMPLE, maxY = 0, found = false;
      for (var j = 0; j < SAMPLE; j++) {
        for (var i = 0; i < SAMPLE; i++) {
          var p = (j * SAMPLE + i) * 4;
          if (Math.abs(d[p] - bg[0]) + Math.abs(d[p + 1] - bg[1]) + Math.abs(d[p + 2] - bg[2]) > 34) {
            found = true;
            if (i < minX) minX = i;
            if (i > maxX) maxX = i;
            if (j < minY) minY = j;
            if (j > maxY) maxY = j;
          }
        }
      }
      if (!found) return 1;
      var nx = Math.max(Math.abs(minX / SAMPLE - 0.5), Math.abs(maxX / SAMPLE - 0.5));
      var ny = Math.max(Math.abs(minY / SAMPLE - 0.5), Math.abs(maxY / SAMPLE - 0.5));
      var safe = (0.5 / Math.max(nx, ny)) * MARGIN;
      var span = Math.max((maxX - minX) / SAMPLE, (maxY - minY) / SAMPLE);
      return Math.max(1, Math.min(TARGET / span, safe, CAP));
    }

    function apply(img) {
      if (img.dataset.zchZoom) return;
      img.dataset.zchZoom = 'pending';
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var z = computeZoom(probe);
          if (z > 1.01) img.style.transform = 'scale(' + z.toFixed(3) + ')';
          img.dataset.zchZoom = z.toFixed(3);
        } catch (e) {
          img.dataset.zchZoom = 'error';
        }
      };
      probe.onerror = function () {
        img.dataset.zchZoom = 'error';
      };
      probe.src = img.currentSrc || img.src;
    }

    document.querySelectorAll('[data-zch-thumbs] .zch__thumb img').forEach(function (img) {
      if (img.complete && img.naturalWidth) {
        apply(img);
      } else {
        img.addEventListener('load', function () { apply(img); }, { once: true });
      }
    });
  })();
})();
